import { SelectInput, SelectInputProps, useTranslate } from 'react-admin';
import { InputLabel } from '@mui/material';
import { InputHelperUnderLabel } from './InputHelperUnderLabel';

export const GraySelectInputWithUpperLabel = (props: SelectInputProps) => {

  const translate = useTranslate();
  const {
    helperText, label, className, ...rest
  } = props;

  return (
    <>
      {label !== false && (
        <InputLabel className="input-label">
          {translate(typeof label === 'string' ? label : '', { _: label })}
        </InputLabel>
      )}
      <InputHelperUnderLabel helperText={helperText} />
      <SelectInput
        {...rest}
        className={className ? `${className} bhvk-gray-input` : 'bhvk-gray-input'}
        label={false}
        InputProps={{ ...props.InputProps, notched: false }}
        sx={{
          mt: 0,
          mb: 0,
          ...props.sx,
          '& .MuiOutlinedInput-root': {
            boxSizing: 'border-box',
            minHeight: 40,
            height: 40,
            alignItems: 'center',
          },
        }}
      />
    </>
  );

};
